import type { ActionFields } from "src/api/sure-api/actions/useGetOneAction";

/**
 * Détecte si un ID est un UUID ou un ID numérique
 */
export const isUUID = (id: string): boolean => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(id);
};

/**
 * Détermine si une action est du catalogue (ID numérique) ou du plan (UUID)
 */
export const isActionFromCatalog = (actionId: string | undefined): boolean => {
    if (!actionId) return false;
    return !isUUID(actionId);
};

/**
 * Détermine si une action est du plan d'action (UUID)
 */
export const isActionFromPlan = (actionId: string | undefined): boolean => {
    if (!actionId) return false;
    return isUUID(actionId);
};

/**
 * Crée l'IRI d'un post SSQ
 */
export const makePostIRI = (postId: number | undefined): string | undefined => {
    if (postId === undefined) return undefined;
    return `/api/ssq-posts/${postId}`;
};

/**
 * Récupère les propriétés SSQ d'une action catalogue pour affichage
 */
export const getCatalogActionProperties = (catalogAction: any) => {
    return catalogAction?.ssqProperties || [];
};

export type ActionEmptyOptions = {
    actionFields?: ActionFields[];
    ssqProperties: {
        code?: string | undefined;
    }[];
};
export const isActionEmpty = (action: ActionEmptyOptions | undefined) => {
    if (action === undefined) {
        return true;
    }

    return (action.actionFields ?? []).length === 0;
};

type ActionMultilevelOptions = {
    ssqProperties: {
        generalizations?: unknown[];
    }[];
};
export const isActionMultilevel = (action: ActionMultilevelOptions | undefined) => {
    if (action === undefined) {
        return false;
    }

    const isMultilevel = action.ssqProperties.some((property) => {
        return !!property.generalizations?.length;
    });
    return isMultilevel;
};
